import {BrowserRouter, Outlet, Route, Routes} from 'react-router-dom'
import APP_ROUTES from "./routes"
import React from "react"
import Scaffold from "./view/components/layout/scaffold/Scaffold"
import HeaderNav from "./view/components/layout/header/HeaderNav"
import RouteUtils from "./domain/utils/RouteUtils"
import Lui from "./view/components/lui/Lui"
import {Config} from "./domain/config/Config"
import AppState from "./domain/contexts/AppState"
import {observer} from "mobx-react"


/**
 * APP
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function App() {
    // инициализация сервисов
    AppState.instance.init()

    // вывод
    return ( <AppRouter /> )
}


/**
 *  Основной роутер
 */
const AppRouter = observer(() => {
    const routes = APP_ROUTES[ AppState.instance.lang ]
    // вывод
    return (
        <BrowserRouter basename={ Config.baseUrl }>
            <Routes>
                <Route path='/' element={<AppLayout routes={routes} />}>
                    { RouteUtils.createRoutes(routes) }
                </Route>
            </Routes>
        </BrowserRouter>
    )
})


/**
 * LayOut
 *
 * @param {AppRoute[]} routes
 * @returns {JSX.Element}
 * @constructor
 */
const AppLayout = ({ routes })=>(
    <Lui>
        <Scaffold header={<HeaderNav routes={routes} title='Admin'/>} >
            <Outlet />
        </Scaffold>
    </Lui>
)


